import { render, staticRenderFns } from "./hqglLogisticsDisposeDetail.vue?vue&type=template&id=6e880452&scoped=true&"
import script from "./hqglLogisticsDisposeDetail.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsDisposeDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglLogisticsDisposeDetail.vue?vue&type=style&index=0&id=6e880452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e880452",
  null
  
)

export default component.exports